
export default [
    {
        path: '/Center',
        name:'Center',
        meta: { 
          title: '个人中心',
        //   keepAlive: true,
        //   requireAuth:true
        },
          component: () => import('@/views/Personal/Center'),
      },
      {
        path: '/MyOrder',
        name:'MyOrder',
        meta: { 
          title: '我的订单',
        //   keepAlive: true,
        //   requireAuth:true
        },
          component: () => import('@/views/MyOrder/MyOrder'),
      },
      {
        path: '/OrderDetails',
        name:'OrderDetails',
        meta: { 
          title: '订单详情',
        //   keepAlive: true,
        //   requireAuth:true
        },
          component: () => import('@/views/OrderDetails/OrderDetails'),
      },
      {
        path: '/Student',
        name:'Student',
        meta: { 
          title: '学员管理',
        //   keepAlive: true,
        //   requireAuth:true
        },
          component: () => import('@/views/Student/Student'),
      },
      {
        path: '/AddStudent',
        name:'AddStudent',
        meta: { 
          title: '添加学员',
        //   keepAlive: true,
        //   requireAuth:true
        },
          component: () => import('@/views/AddStudent/AddStudent'),
      },
      {
        path: '/MyCollect',
        name:'MyCollect',
        meta: { 
          title: '我的收藏',
        //   keepAlive: true,
        //   requireAuth:true
        },
          component: () => import('@/views/MyCollect/MyCollect'),
      },
      {
        path: '/MyCourses',
        name:'MyCourses',
        meta: { 
          title: '我的课程',
        //   keepAlive: true,
        //   requireAuth:true
        },
          component: () => import('@/views/MyCourses/MyCourses'),
      },

      {
        path: '/CancelOrder',
        name:'CancelOrder',
        meta: { 
          title: '取消订单',
        //   keepAlive: true,
        //   requireAuth:true
        },
          component: () => import('@/views/CancelOrder/CancelOrder'),
      },
      {
        path: '/Account',
        name:'Account',
        meta: { 
          title: '账号管理',
        //   keepAlive: true,
        //   requireAuth:true
        },
          component: () => import('@/views/Account/Account'),
      },
      {
        path: '/ChangePassword',
        name:'ChangePassword',
        meta: { 
          title: '修改密码',
        //   keepAlive: true,
        //   requireAuth:true
        },
          component: () => import('@/views/ChangePassword/ChangePassword'),
      },
      

]



// WEBPACK FOOTER //
// ./src/router/personal/Center.js